import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const APP_TIMEZONE = process.env.REACT_APP_TIMEZONE || "Asia/Colombo";

export const getAppNow = () => dayjs().tz(APP_TIMEZONE);

export const toAppCalendarDay = (value) => {
    if (!value) return null;

    const base = dayjs.isDayjs(value) ? value : dayjs(value);
    if (!base.isValid()) return null;

    return base.tz(APP_TIMEZONE, true);
};

export const toAppDateTime = (value) => {
    if (!value) return null;

    const base = dayjs.isDayjs(value) ? value : dayjs(value);
    if (!base.isValid()) return null;

    return base.tz(APP_TIMEZONE);
};

export const buildApiDateRangeParams = (start, end) => {
    const appStart = toAppCalendarDay(start);
    const appEnd = toAppCalendarDay(end);

    if (!appStart || !appEnd) {
        return {};
    }

    const normalizedStart = appStart.startOf("day");
    const normalizedEnd = appEnd.startOf("day").add(1, "day");

    return {
        from: normalizedStart.toISOString(),
        to: normalizedEnd.toISOString(),
    };
};

export const resolveDateRange = (type, customRange = [null, null]) => {
    if (type === "custom") {
        return customRange || [null, null];
    }

    const now = getAppNow();

    switch (type) {
        case "today":
            return [now.startOf("day"), now.endOf("day")];
        case "yesterday": {
            const yesterday = now.subtract(1, "day");
            return [yesterday.startOf("day"), yesterday.endOf("day")];
        }
        case "last7":
            return [now.subtract(6, "day").startOf("day"), now.endOf("day")];
        case "last30":
            return [now.subtract(29, "day").startOf("day"), now.endOf("day")];
        case "thisMonth":
            return [now.startOf("month"), now.endOf("month")];
        case "lastMonth": {
            const lastMonth = now.subtract(1, "month");
            return [lastMonth.startOf("month"), lastMonth.endOf("month")];
        }
        case "last3months":
            return [now.subtract(2, "month").startOf("month"), now.endOf("month")];
        case "last6months":
            return [now.subtract(5, "month").startOf("month"), now.endOf("month")];
        case "last12months":
            return [now.subtract(11, "month").startOf("month"), now.endOf("month")];
        default:
            return [null, null];
    }
};

export const formatAppDateTime = (value, format = "DD/MM/YYYY, hh:mm:ss A") => {
    if (!value) return "-";
    const formatted = toAppDateTime(value);
    return formatted.isValid() ? formatted.format(format) : "-";
};

export const formatAppDate = (value, format = "DD/MM/YYYY") => {
    if (!value) return "-";
    const formatted = toAppDateTime(value);
    return formatted.isValid() ? formatted.format(format) : "-";
};

export const formatAppRangeLabelDate = (value, format = "MMM D, YYYY") => {
    if (!value) return "";
    const formatted = toAppCalendarDay(value);
    return formatted?.isValid?.() ? formatted.format(format) : "";
};
